module.exports = __webpack_public_path__ + "img/autospin_btn.0bc1dbbf.png";